export const AUTO_CONFIGURATOR_SLICE_NAME = 'autoConfigurator';
